import { fetchCertificates } from "@/services/supabaseService";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Calendar } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { optimizedSupabaseImage } from "@/lib/utils";

const Certificates = () => {
  const navigate = useNavigate();
  const navigateToPage = (path: string) => {
    navigate(path);
  };

  const { data: certifications = [] } = useQuery({
    queryKey: ["certificates"],
    queryFn: fetchCertificates,
  });

  // Show only first 2 certificates
  const displayCertificates = certifications.slice(0, 2);

  return (
    <div id="certificates" className="container max-w-6xl mx-auto py-20 px-6">
      <div className="animate-slide-down">
        <h2 className="text-4xl font-bold mb-2 text-teal">
          Certifications
        </h2>
        <p className="text-gray-400 mb-6">
          Professional certifications showcasing continuous learning and industry credentials.
        </p>
      </div>

      <div
        className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8"
      >
        {displayCertificates.map((cert, index) => (
          <div
            key={cert.id}
            className="glass-morphism rounded-xl p-5 flex items-center gap-4 animate-fade-in group hover:scale-[1.02] hover:shadow-xl hover:shadow-teal/20 hover:border hover:border-teal/30 transition-all duration-300 cursor-pointer"
            style={{ animationDelay: `${0.1 + index * 0.1}s` }}
          >
            <img
              src={optimizedSupabaseImage(cert.logo, 96)}
              alt={`${cert.name} logo`}
              className="w-12 h-12 rounded-md object-cover transition-transform duration-300 group-hover:scale-110"
              loading="lazy"
              decoding="async"
              width="96"
              height="96"
            />
            <div className="flex-1">
              <h3 className="font-medium text-white transition-colors duration-300 group-hover:text-teal">
                {cert.name}
              </h3>
              <p className="text-sm text-gray-400">
                Issued by {cert.issuer}
              </p>
              <div className="flex items-center mt-1">
                <Calendar className="h-3 w-3 mr-1.5 text-gray-500" />
                <span className="text-xs text-teal">{cert.date}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-12">
        <Button
          onClick={() => navigateToPage("/education")}
          className="bg-teal hover:bg-teal-dark text-navy-dark flex items-center gap-2"
        >
          View More
          <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default Certificates;
